import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { BiddingSearchProvider } from './context/bidding-search-context';
import { BiddingSearchComponent } from './bidding-search-component';

export function BiddingSearchFactory() {
    return (
        <BaseLayoutFactory>
            <BiddingSearchProvider>
                <BiddingSearchComponent />
            </BiddingSearchProvider>
        </BaseLayoutFactory>
    );
}
